import type { ShopProductDetail, ShopVariant } from "./printify";

function sameSet(a: number[], b: number[]): boolean {
  if (a.length !== b.length) return false;
  const sa = [...a].sort((x, y) => x - y);
  const sb = [...b].sort((x, y) => x - y);
  return sa.every((v, i) => v === sb[i]);
}

/** The enabled variant whose option-value ids equal the selection, or null. */
export function resolveVariant(variants: ShopVariant[], selectedValueIds: number[]): ShopVariant | null {
  return variants.find((v) => sameSet(v.optionValueIds, selectedValueIds)) ?? null;
}

/** Initial picker state: the first available variant, else the first variant. */
export function defaultSelection(product: ShopProductDetail): number[] {
  const v = product.variants.find((x) => x.isAvailable) ?? product.variants[0];
  return v ? [...v.optionValueIds] : [];
}

/**
 * The mockup that depicts the chosen variant (its color), so the cart shows the
 * actual shirt/hat the shopper picked — not the default white mockup. `gallery`
 * is front-camera-first, so the first match is that color's hero shot. Falls
 * back to the product's default front mockup when nothing is tagged to the
 * variant (or on older cached catalog data).
 */
export function pickVariantImage(product: ShopProductDetail, variant: ShopVariant | null): string {
  const gallery = product.gallery ?? [];
  if (variant) {
    const match = gallery.find((g) => g.variantIds.includes(variant.id));
    if (match) return match.src;
  }
  return product.frontMockup;
}
